import produce from "immer";

const defaultState = {
	items: null
};

export default function(state = defaultState, action) {
	switch (action.type) {
		case 'FETCH_REWARD_CLAIM_HISTORY':
			return defaultState;
		case "REWARD_CLAIM_HISTORY_FETCHED":
			return produce(state, draft => {
				draft.items = action.rewardClaimHistory.map(claim => {
					return {
						id: claim.id,
						orderDate: claim.orderDate,
						amount: claim.amount
					};
				});
			});
		default:
			return state;
	}
}